var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeAsset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 39,
    viewBox: "0 0 14 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 39,
    fill: "url(#pattern0_223_1114)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_223_1114",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_223_1114",
    transform: "matrix(0.025641 0 0 0.00920447 0 -0.0200526)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_223_1114",
    width: 39,
    height: 113,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAABxCAYAAABWdLrfAAAACXBIWXMAAAsSAAALEgHS3X78AAAEoUlEQVR4nO2csW8bVRyAP19MGtxCMkRCSocm6cKUVHpiKUh1kcJaq0PZwJGYvJAKiRUzI0S6pFRCissfAM6EwBI4UsqCnuRkgqFKIgFSpA5JSaMmcXIM9y51zmffvedHHOB90+X87neff/fud5e795zxfR8AKeUIUAaKwDD9YQkoCyEaABnf95FSjgN14EqfpKLMCiEqoVwDmO63UYQJT0pZ4PyJAZQ9IN9viw4UssA1jQ3uCSHmTPcmpawA76dsPuxpxN7sRUwxB2ymbawjV9RWiSCE2CYoV6nIAhvAjYR2z4GylNJYLEJT7bsrWYL6ltQPhkj+ArZZ8oAqsHPGO07DvKf6QZ7zJXhPCFH3ANS1LA8s91UJngF3w6qQCS/8IVJKP2aju0DDsshXwNXIuptCiHr4R+IZo2i0bmQDKeXvtMudQqfOnTlOzhQnZ4qTM8XJmeLkTHFypjg5U5ycKU7OFCdnipMzxcmZ4uRMSfusJJa9hZkRgsexBU4/XNwkeO43nyvVNkzjG2dub2EmT/Dk6Qvan3peAT4EGnsLM8UzlVM7/Ink11HDwKKpoLbc3sLMODCvudmiyrQWJpkrY/ZWsay7gZacOgHSvoGJckNlPTW6mdN5FRVHQaexrlxes32UEZ3G57oIOzlTnJwpTs4UJ2eKkzPl/yXnjXZ9haoXy1ok4KU33mPozpcMFT63Es+qXPb1d4KgY1NWMmhVLvPKay+WL1zqOZ5VueZvPwDgHzzj6I/VnuP19E91lMOV+/hPtzhaf2QlnlU5f3+X5q/f4/+1ZSWe3T534RJD7z5gYOJNK/GM5QYuT/PyB1WG7jw46fze2DSZwYsMTF7vr1x26jaZwYt4o5N4Y8GQz6P1RzTXvuVw5b4VOeM+11oqMq++KCEHKwu9GbVgnLnWUnFsoWzEYZy5w1++xj/YxX+6xfGTxzadTuiplDRXv7HlEcu5vmWyUoS90asMvlXC39/l4MfP8Pd3bYS1k7nBtz/GG5tiYOI62anbNkICluS80cmT5YHL9oa5n+s+Z0Wu9UJv41YpxIrc/nefcPznGkfrP9Ncs1derJytx08e87z6kY1Qp/jv97l/CidnipMzxcmZ4uRMcXKm/OvkzmoWU+K71zi5bhOBep0ktN2ynHg/n/awhq/P67o2EepAOBO5jegkpLSZywPkSrVt4KGh2HKuVAtj52M+b5u9GSdXj1l3S00Ih2AIhkm/LLcsxw1EaEtKWjkI5qaixibl0ROczZVqdTg5pLdi2lQT5dTcw6U4ubCvqMNzjeTpf5vAzVypVmlZV4lptxMn1zadD0BKmScYqxRlFcirLwCcDB8qKNlxtboONHKl2qkdSinnCAZmRXkohCimklOB6sTPaW0TTIOUsggsxny0A4zHxetWSorE96tpYEPtLI3UiJSy2kEMgl88iP2iHTOnAhe7BIWgT1WAerRGqa5RJDjknQZmLQkhOg4h6iqXUtCUxO6ReIUQQlSAWYtSEJzlif02MXMhUsprBKd7rz9+8akQopymYWq5EHWYy+hLnvq5jzRoy4WoTBYJ6lunafTLBNmuCiE2dPfxN0WaX5adCNmvAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeAsset);
export default __webpack_public_path__ + "static/media/tube_asset.04a0c7eabf2344cffed55fc9b2dda335.svg";
export { ForwardRef as ReactComponent };